// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2A0xY","vLegacy":"SelectSecondary_vLegacy__3rd1M","error":"SelectSecondary_error__eDEXc","disabled":"SelectSecondary_disabled__2JvpG"};